var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConfigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,11H1a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H4a1,1,0,0,0,1-1V12A1,1,0,0,0,4,11ZM3.25,8.5h6V10h1.5V8.5h6V10h1.5V8.2A1.2,1.2,0,0,0,17,7h-6.3V5H12a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1H8A1,1,0,0,0,7,1V4A1,1,0,0,0,8,5H9.25V7H3a1.2,1.2,0,0,0-1.2,1.2V10h1.5ZM11.5,11h-3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V12A1,1,0,0,0,11.5,11ZM19,11H16a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V12A1,1,0,0,0,19,11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfigure);
export default __webpack_public_path__ + "static/media/icon-configure.2ba3bc888d40fba92c0a4d7f7140d3cc.svg";
export { ForwardRef as ReactComponent };